<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12 requestcancellation">
                <div class="card">
                    <!-- <form @submit.prevent="processRequestCancellation" method="post"></form> -->
                    <h4 class="font-weight-bold requestcancellation__title" id="form-entry">{{
                    TEXTS.render(`REQUESTCANCELLATION_HEADER`) }}</h4>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group mb-4">
                                <label class="font-weight-bold mb-1">
                                    {{TEXTS.render(`REQUESTCANCELLATION_PROPERTY_ADDRESS`) }}
                                </label>
                                <BookingSearch @clearSearchString="clearData" :isReducedView="true" :clearAfterSelect="false" :showLabel="false" :dark="true" />
                                <input type="hidden" class="form-control" v-model="details.propertyAddress" required />
                                <div
                                    v-if="
                                        $store.getters.GET_SEARCHED_ADDRESSES.fetched &&
                                        $store.getters.GET_SEARCHED_ADDRESSES.list.length === 0
                                    "
                                    class="requestcancellation__validation mt-1 text-danger font-weight-bold"
                                    v-html="noResultsText">
                                </div>
                                <div class="requestcancellation__validation mt-1 text-danger font-weight-bold" v-html="validations.propertyAddress"></div>
                            </div>
                            <div class="form-group mb-4">
                                <label class="font-weight-bold mb-1">{{ TEXTS.render(`REQUESTCANCELLATION_CRN`)}}</label>
                                <!-- <input type="text" class="form-control" :placeholder="TEXTS.render(`REQUESTCANCELLATION_CRN_PLACEHOLDER`)" v-model="details.crn"> -->
                                <select class="form-control" v-model="details.crn" required
                                    :disabled="!crns || !((Object.keys(crns)).length > 0)">
                                    <option disabled selected value="">
                                        {{TEXTS.render(`REQUESTCANCELLATION_CRN_PLACEHOLDER`)}}
                                    </option>
                                    <option v-for="item in crns" v-bind:key="item.CRN" :value="item.CRN">
                                        {{item.CRN}}
                                    </option>
                                </select>
                                <div class="requestcancellation__validation mt-1 text-danger font-weight-bold" v-html="validations.crn"></div>
                            </div>
                            <div class="form-group mb-4">
                                <label class="font-weight-bold mb-1">{{ TEXTS.render(`REQUESTCANCELLATION_REQUEST_DATE`)
                                }}</label>
                                <input type="text" class="form-control" v-model="details.requestDate" required readonly
                                    disabled />
                                <div class="requestcancellation__validation mt-1 text-danger font-weight-bold" v-html="validations.requestDate"></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <ColoredButton v-on:click="processRequestCancellation" :disabled="loading || !validations.valid"
                                :loadingState="loading" class="skiptranslate">
                                {{ TEXTS.render(`REQUESTCANCELLATION_BTN_SUBMIT`) }}
                            </ColoredButton>
                        </div>
                    </div>
                    <RequestCancellationSuccessModal modalId="requestCancellationSuccesModal"
                        triggerEventName="requestCancellationSuccesModal" />
                    <RequestCancellationFailedModal modalId="requestCancellationFailedModal"
                        triggerEventName="requestCancellationFailedModal" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ColoredButton from '../../../../common/components/ColoredButton';
import RequestCancellationSuccessModal from '../../../../common/components/RequestCancellationSuccessModal';
import RequestCancellationFailedModal from '../../../../common/components/RequestCancellationFailedModal';
import BookingSearch from "../../../../common/components/BookingSearch";
import Texts from '../../../../common/utils/Texts';
import helper from '../../../../helper';

export default {
    components: {
        ColoredButton,
        RequestCancellationSuccessModal,
        RequestCancellationFailedModal,
        BookingSearch
    },
    data() {
        return {
            delayTime: 0,
            details: {
                propertyAddress: '',
                crn: '',
                personalInfo: '',
                requestDate: ''

            },
            validations: {
                propertyAddress: '',
                crn: '',
                requestDate: '',
                valid: false
            },
            crns: null
        }
    },
    computed: {
        TEXTS: () => Texts,
        loading() {
            return this.$store.getters['GET_PERSONAL_INFO'].loading;
        },
        requestCancellationSuccess() {
            return this.$store.getters['GET_VALIDATE_REQUEST_CANCELLATION_RESULT'];
        },
        workOrderObject: function () {
            return this.$store.getters.GET_WORK_ORDER || null;
        },
        activeAddress() {
            return this.$store.getters.GET_ACTIVE_ADDRESS
        },
        noResultsText() {
            if (this.siteWordings && this.siteWordings.no_search_result_text) {
                return this.siteWordings.no_search_result_text
            } else {
                return Texts.render('ADDRESS_SEARCH_NOTFOUND')
            }
        },
        fetchAddress() {
            return this.$store.getters.GET_SEARCHED_ADDRESSES.fetched;
        },
        settings() {
            return this.$store.getters.GET_CANCELLATION_SETTING;
        },
        cancellationDay() {
            return (this.settings && this.settings.cancellation_day) ? parseInt(this.settings.cancellation_day) : 2;
        },
        errorMessage() {
            return (this.settings && this.settings.cancellation_error) ? this.settings.cancellation_error : null;
        }
    },
    methods: {
        async processRequestCancellation() {
            //validate value
            await this.validateAll();
            await this.$store.dispatch('clearValidateRequestCancellationResult');

            if (!this.validations.valid) {
                helper.scrollIntoView('form-entry');
            }

            if (this.validations.valid) {
                this.$store.dispatch('requestCancellationProcess', {
                    propertyAddress: this.details.propertyAddress,
                    crn: this.details.crn,
                    personalInfo: this.$store.getters['GET_PERSONAL_INFO']
                });
            }

        },
        validateAll() {
            this.validations.valid = true;
            this.propertyAddressValidate();
            this.crnValidate();
        },
        propertyAddressValidate() {
            this.validations.propertyAddress = '';
            if (this.details.propertyAddress == '') {
                this.validations.valid = false;
                this.validations.propertyAddress = Texts.render(`REQUESTCANCELLATION_PROPERTY_ADDRESS_VALIDATION`);
            }
        },
        crnValidate() {
            this.validations.crn = '';
            this.validations.requestDate = '';
            if(!this.details.crn || this.details.crn == '') {
                this.validations.valid = false;
                this.validations.crn = Texts.render(`REQUESTCANCELLATION_CRN_VALIDATION`);

                return;
            }

            const crn = this.crns[this.details.crn] || null;
            if (!crn || !crn.woRequestedDateTime) {
                this.validations.valid = false;
                this.validations.crn = Texts.render(`REQUESTCANCELLATION_CRN_VALIDATION`);
            } else {
                this.details.requestDate = this.formatDate(crn.woRequestedDateTime);
                if (!this.isValidCRNDate(crn.woRequestedDateTime)) {
                    this.validations.valid = false;
                    this.validations.requestDate = this.errorMessage || Texts.render(`REQUESTCANCELLATION_CRN_DATE_VALIDATION`, null, { requestDate : this.formatDate(crn.woRequestedDateTime), cancelDay: this.cancellationDay });
                }
            }
        },
        isValidCRNDate(date) {
            var leadTime = this.cancellationDay,
                d1 = new Date();

            for (let index = 1; index <= leadTime; index++) {
                var day = d1.getDay();
                if (day == 6 || day == 0) {
                    leadTime++
                }
                d1.setDate(d1.getDate() + 1);
            }

            while(d1.getDay() == 0 || d1.getDay() == 6) {
                d1.setDate(d1.getDate() + 1);
            }

            const leadDate = new Date(new Date(d1).setHours(0,0,0,0));
            const requestDate = new Date((new Date(date.split(' ')[0])).setHours(0,0,0,0));
            if(leadDate < requestDate) {
                return true;
            }

            return false;
        },
        formatDate(date) {
            date = new Date(date);
            return [
                this.padTo2Digits(date.getDate()),
                this.padTo2Digits(date.getMonth() + 1),
                date.getFullYear(),
            ].join('/');
        },
        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },
        groupWorkOrders(workOrders) {
            let workOrderGroups = {};
            workOrders.forEach((workOrder) => {
                var orderKey = `${workOrder.CRN}`;

                if (!workOrderGroups[orderKey]) {
                    workOrderGroups[orderKey] = {
                        ...workOrder,
                    };
                    workOrderGroups[orderKey].orders = [workOrder];
                } else {
                    let foundGroup = workOrderGroups[orderKey];
                    foundGroup.orders.push(workOrder);
                }

                if (workOrder.WOIWasteType && workOrder.WOIWasteType != "") {
                    workOrder.hasWoi = true;
                    workOrderGroups[orderKey].hasWoi = true;
                }
            });

            return workOrderGroups;
        },
        async clearData() {
            this.validations = {
                propertyAddress: '',
                crn: '',
                requestDate: '',
                valid: false
            }

            this.details = {
                propertyAddress: '',
                crn: '',
                personalInfo: '',
                requestDate: ''
            }

            this.crns = null;
        },
    },
    watch: {
        'error': function (message) {
            this.$nextTick(function () {
                this.errorMessage = message
                helper.scrollIntoView('form-entry');
            })
        },
        'activeAddress': function () {
            this.clearData();
            
            clearTimeout(this.delayTime);

            this.delayTime = setTimeout(() => {
                if (this.activeAddress) {
                    this.details.propertyAddress = helper.addressTransform([this.activeAddress])[0].displayName || '';
                    this.$store.dispatch("getWorkOrder", this.activeAddress.id);
                }
            }, 500)
        },
        'details.crn': function (val) {
            if(val !== '')
                this.validateAll();
        },
        'requestCancellationSuccess': function () {
            var result = this.$store.getters.GET_VALIDATE_REQUEST_CANCELLATION_RESULT;
            if (result == null) {
                //Triggered when success cancellation
                $('#requestCancellationSuccess').modalbs5({
                    backdrop: 'static',
                    keyboard: false
                });
            } else {
                $('#requestCancellationFailed').modalbs5({
                    backdrop: 'static',
                    keyboard: false
                });
            }
        },
        'workOrderObject': function () {
            if (this.workOrderObject && this.workOrderObject.workOrders) {
                const workOrders = this.workOrderObject.workOrders;
                this.crns = this.groupWorkOrders(workOrders.filter(x =>
                    x.woStatus.toLowerCase().indexOf('completed') === -1 &&
                    x.woStatus.toLowerCase().indexOf('cancelled') === -1
                ));
            }
        },
        'fetchAddress': function() {
            if(this.fetchAddress) {
                this.clearData();
            }
        }
    }
}
</script>
